<div class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg primary"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center" style="width: 100%;">

        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
        </div>
        <!-- / CONTENT HEADER -->
        <!-- CONTENT CARD -->
        <div class="content-card " style="border-color: transparent">
            <img src="{{urlBanner}}" alt="Logo-Norm35" class="centradoIMG ">
        </div>
        <!-- / CONTENT -->
    </div>
    <!-- / CONTENT CARD -->
    <!-- CONTENT -->
    <div class="content-card" style="margin-top: 2%; margin-left: 5%; margin-right: 15%;">
        <div aling="center">

        </div><br>
        <div>

            <p>{{ 'WIZARD.CAMPO_APLICACION.TITLE' | translate }}</p>

            <ul>{{ 'WIZARD.CAMPO_APLICACION.MENU.SUB1' | translate }} </ul>

            <ul>{{ 'WIZARD.CAMPO_APLICACION.MENU.SUB2' | translate }} </ul>

            <ul>{{ 'WIZARD.CAMPO_APLICACION.MENU.SUB3' | translate }} </ul>

            <p>{{ 'WIZARD.CAMPO_APLICACION.SUBTITLE' | translate }} </p>
            <ul>
                {{ 'WIZARD.CAMPO_APLICACION.MENUSUB.SUB1' | translate }}

            </ul>

        </div><br>


    </div><br><br><br><br><br><br><br><br>

</div>
<!-- / CENTER -->